import {ChangeDetectionStrategy, Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AssetSvgSource} from 'src/app/common/models/ai-reports/shared/assets';
import {environment} from 'src/environments/environment';
import {AbstractAssetComponent} from '../abstract-asset.component';

@Component({
  selector: 'app-asset-svg-source',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './asset-svg-source.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetSvgSourceComponent extends AbstractAssetComponent<AssetSvgSource> {

  getUrl(): string {
    const a = this.asset();
    return `${environment.apiBaseUrl}${environment.endpoint.assets.image}/${a.id}`
  }
}
